import React from 'react';

import { useSelector } from 'react-redux';
import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import AppState from '@webapp/store/state';

import Grid from '@components/basics/grid';
import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import SquareImg from '@components/basics/artwork-img';

import { MerchProduct } from '@services/merch/types/api/merch-product';
import { getMergedReleaseListSummary } from '@webapp/store/release/selectors';

interface ArtistMobileMerchRowProps {
  item: MerchProduct;
}

export default function ArtistMobileMerchRow({
  item,
}: ArtistMobileMerchRowProps) {
  const release = useSelector((state: AppState) =>
    getMergedReleaseListSummary(state).find((r) => r.id === item.releaseId)
  );

  return (
    <Wrapper>
      <Flex justifyContent="space-between" alignItems="center" gap={10}>
        {!item.releaseId ? (
          <Typography type="small">—</Typography>
        ) : (
          <Flex justifyContent="flex-start" alignItems="center" gap={20}>
            <SquareImg
              size={36}
              srcImg={release?.cover_url}
              altImg={item.releaseName}
            />
            <Grid gap={3}>
              <Typography customFont="semi-bold">{release?.title}</Typography>
              {release?.upc ? (
                <Typography type="small">{release.upc}</Typography>
              ) : null}
            </Grid>
          </Flex>
        )}
      </Flex>
      <Flex justifyContent="space-between" alignItems="center" gap={10}>
        {/* <Typography weight="700">
          <Translate id="CATALOG.MERCH.HEADER.QUALITY" />
        </Typography> */}
        {/* TODO: Quality is not typed in MerchProduct */}
        {/* <Typography type="small">{item.quality}</Typography> */}
      </Flex>
      <Flex justifyContent="space-between" alignItems="center" gap={10}>
        <Typography weight="700">
          <Translate id="CATALOG.MERCH.HEADER.QUANTITY_LEFT" />
        </Typography>
        <Typography align="right" type="small">
          {item.unlimitedQty ? (
            <Translate id="COMMON.UNLIMITED" />
          ) : item.availableQty ? (
            item.availableQty
          ) : (
            0
          )}
        </Typography>
      </Flex>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: grid;
  grid-gap: 10px;
`;
